export default __webpack_public_path__ + "static/media/cm.3d01955a.svg";